import React from 'react';

const ManufacturerSec4 = () => {
    return (
        <div className='flex flex-col justify-center items-center mt-10 w-[90vw] md:w-[80vw] mx-auto'>
            
        </div>
    );
};

export default ManufacturerSec4;